import { List } from 'antd';
import { observer } from 'mobx-react-lite';
import { EntityPresentation } from 'src/components/EntityPresentation/EntityPresentation';
import { MasterDetailsAside } from 'src/components/MasterDetailsPage/MasterDetailsAside';
import { MasterDetailsPage } from 'src/components/MasterDetailsPage/MasterDetailsPage';
import { LoanProduct } from 'src/generated-api-client';
import { ProductsHeaderPanel } from 'src/pages/ProductsPage/ProductsHeaderPanel';
import { ProductListItem } from 'src/pages/ProductsPage/ProductsListItem';
import { ProductsStore } from 'src/stores/ProductsStore/ProductsStore';

export const ProductsPage = observer(() => {
    return (
        <MasterDetailsPage
            pageName="products"
            store={store}
            asidePanel={<ProductsAsidePanel />}
            data-testid="products-page"
        >
            <EntityPresentation store={store} entityName="product" />
        </MasterDetailsPage>
    );
});

const ProductsAsidePanel = observer(() => {
    return (
        <MasterDetailsAside
            store={store}
            renderItem={(product: LoanProduct) => {
                return (
                    <List.Item
                        key={product.id}
                        data-testid={`master-details-list-item-${product.id}`}
                    >
                        <ProductListItem product={product} />
                    </List.Item>
                );
            }}
            header={<ProductsHeaderPanel />}
        />
    );
});

const store = ProductsStore;
